import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'working_hour_records_each_worker'

export const dataPointDefinition = {
  retracedId: 'working_hour_records_each_worker',
  name: "Working hour records for each worker's regular and overtime hours are not maintained",
  description:
    'The intent of this option selection is to understand if working hour documents clearly show how many "Regular" hours and "Overtime" hours a worker has worked. ',
  meta: {
    slcpMeta: {
      key: 'wh-wor-23x',
      number: 'WH-WOR-4-2',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wh-wor-23x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36520,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
